import axios from "axios"
import { saveAs } from "file-saver" // (Bleibt für andere Funktionen erhalten)

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal // Der wichtigste Teil: Hängt das Token automatisch an

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

export default {
  leaveChatGroup(groupId) {
    const url = buildUrl(`chat/groups/${groupId}/leave`)
    return axios.post(url, {}, buildOptions())
  },
  fetchGroupMedia(groupId, page = 0) {
    const url = buildUrl(`chat/groups/${groupId}/media`)
    const options = {
      params: {
        page: page,
      },
    }
    return axios.get(url, buildOptions(options))
  },
  fetchSecuredMedia(filename) {
    const url = buildUrl(`chat/media/${filename}`)
    // Wichtig: responseType 'arraybuffer' (oder 'blob')
    // 'buildOptions' muss 'responseType' korrekt verarbeiten!
    return axios.get(url, buildOptions({ responseType: "arraybuffer" }))
  },
  uploadChatMedia(groupId, formData) {
    const url = buildUrl(`chat/groups/${groupId}/media`)
    return axios.post(url, formData, buildOptions({ headers: { "Content-Type": "multipart/form-data" } }))
  },
  fetchCommonGroups(targetUserId) {
    const url = buildUrl(`chat/users/${targetUserId}/common-groups`)
    return axios.get(url, buildOptions())
  },
  createGroup(groupData) {
    const url = buildUrl("chat/groups") // Wir übergeben die 'groupData' als Body der POST-Anfrage // 'buildOptions' hängt automatisch den Auth-Header an
    return axios.post(url, groupData, buildOptions())
  },
  addChatMembers(groupId, memberIds) {
    const url = buildUrl(`chat/groups/${groupId}/members`)
    const payload = { memberIds } // Die API erwartet ein Objekt mit 'memberIds'
    return axios.post(url, payload, buildOptions())
  },
  /**
   * Holt alle Chat-Gruppen für den eingeloggten User
   */ fetchGroups() {
    const url = buildUrl("chat/groups")
    return axios.get(url, buildOptions())
  },
  /**
   * Holt alle Nachrichten für eine spezifische Gruppen-ID
   * @param {string} groupId - Die ID der Chat-Gruppe
   */ fetchMessagesForGroup(groupId) {
    // Wir bauen die ID sicher in die URL ein
    const url = buildUrl(`chat/groups/${groupId}/messages`)
    return axios.get(url, buildOptions())
  },
  updateGroup(groupId, updateData) {
    // updateData = { name, description, bild }
    const url = buildUrl(`chat/groups/${groupId}`)
    return axios.put(url, updateData, buildOptions())
  },

  /**
   * Entfernt ein Mitglied aus einer Gruppe
   */
  kickChatMember(groupId, userIdToRemove) {
    const url = buildUrl(`chat/groups/${groupId}/members/${userIdToRemove}`)
    return axios.delete(url, buildOptions())
  },

  /**
   * Ändert die Rolle eines Mitglieds
   */
  updateChatMemberRole(groupId, userIdToUpdate, newRole) {
    const url = buildUrl(`chat/groups/${groupId}/members/${userIdToUpdate}`)
    return axios.put(url, { role: newRole }, buildOptions())
  },
}
